import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Breadcrumb, FormDetailsItem } from '../../common/components';
import { getBreakdownType, deleteBreakdownType } from '../services/dictionary.service';

class DictBreakdownTypeDetails extends PureComponent {
  state = {
    detailsData: {},
    isLoading: true,
  };

  id = this.props.match.params.id;

  async componentDidMount() {
    const detailsData = await getBreakdownType(this.id);

    this.setState({
      detailsData,
      isLoading: false,
    });
  }

  handleEdit = () => {
    const {
      history,
      match: {
        params: { id },
      },
    } = this.props;

    history.push(`/dictionary/breakdown-type-edit/${id}`);
  }

  handleDelete = async () => {
    const { history } = this.props;

    if (window.confirm('Jesteś pewien, ze chcesz usunąć grupę awarii?')) {
      await deleteBreakdownType(this.id);

      history.goBack();
    }
  }

  render() {
    const {
      detailsData,
      isLoading,
    } = this.state;

    if (isLoading) {
      return null;
    }

    return (
      <>
        <Breadcrumb title="Słownik grup awarii" />
        <div className="content">
          <div className="card">
            <div className="card-header row no-gutters align-items-center justify-content-between">
              Szczegóły grupy awarii
              <div>
                <button
                  type="button"
                  className="btn btn-outline-primary ml-3"
                  onClick={this.handleDelete}
                >
                  Usuń grupę
                </button>
                <button
                  type="button"
                  className="btn btn-outline-primary ml-3"
                  onClick={this.handleEdit}
                >
                  Edytuj grupę
                </button>
              </div>

            </div>
            <div className="card-body">
              <FormDetailsItem label="Nazwa" value={detailsData.name} />
            </div>
          </div>
        </div>
      </>
    );
  }
}

DictBreakdownTypeDetails.defaultProps = {};

DictBreakdownTypeDetails.propTypes = {
  match: PropTypes.objectOf(PropTypes.shape).isRequired,
  history: PropTypes.objectOf(PropTypes.shape).isRequired,
};

export default withRouter(DictBreakdownTypeDetails);
